/**!
 * angular-uuid v0.1.0
 * @copyright 2013 Arunjit Singh <opensrc@ajsd.in>. All Rights Reserved.
 * @license MIT; see LICENCE.
 * [https://github.com/ajsd/angular-uuid.git]
 */
"use strict";angular.module("uuid",[]).service("uuid4",function(){var fmt="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";this.generate=function(){return fmt.replace(/[xy]/g,function(c){var r=Math.random()*16|0,v=c==="x"?r:r&3|8;return v.toString(16)})}});
